<div class="row">
    <div class="col-xl-4">
        <div class="card card-box p-4 mb-5">
            <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                <button class="btn btn-link btn-link-dark p-0 font-size-xl text-dark opacity-8 dropdown-toggle no-caret"
                        dropdownToggle
                        type="button">
                    <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                </button>
                <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                    <ul class="nav nav-pills flex-column p-3">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>My Account</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                        <li class="nav-item nav-item--header text-first font-weight-bold">
                            <span>Heading</span>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar1.jpg"/>
                        </div>
                    </div>
                </div>
                <h3 class="font-weight-bold mt-3">Shania O'Brien</h3>
                <span class="badge mt-1 mb-4 badge-neutral-success text-success font-size-md px-4 py-1 h-auto">User online</span>
                <p class="mb-0 text-black-50">A wonderful serenity has taken possession of my entire soul.</p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-pill btn-github" tooltip="Github" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-instagram" tooltip="Instagram" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-google" tooltip="Google" type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box p-4 bg-night-sky text-white mb-5">
            <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                <button class="btn btn-link btn-link-white p-0 font-size-xl text-white opacity-8 dropdown-toggle no-caret"
                        dropdownToggle
                        type="button">
                    <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                </button>
                <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                    <ul class="nav nav-pills flex-column p-3">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>My Account</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                        <li class="nav-item nav-item--header text-first font-weight-bold">
                            <span>Heading</span>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar2.jpg"/>
                        </div>
                    </div>
                </div>
                <h3 class="font-weight-bold mt-3">Akeem Griffith</h3>
                <span class="badge mt-1 mb-4 badge-warning font-size-md px-4 py-1 h-auto">Pending</span>
                <p class="mb-0 text-white-50"> I am alone, and feel the charm, which was created for mine.</p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-github" tooltip="Github"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-instagram"
                           tooltip="Instagram"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-google" tooltip="Google"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box bg-midnight-bloom text-white p-4 mb-5">
            <div class="btn-group card-tr-actions" dropdown placement="bottom right">
                <button class="btn btn-link btn-link-white p-0 font-size-xl text-white opacity-8 dropdown-toggle no-caret"
                        dropdownToggle
                        type="button">
                    <fa-icon [icon]="['fas', 'ellipsis-h']" class="font-size-lg"></fa-icon>
                </button>
                <div *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-menu-lg overflow-hidden p-0">
                    <ul class="nav nav-pills flex-column p-3">
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>My Account</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link active">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                        <li class="nav-item nav-item--header text-first font-weight-bold">
                            <span>Heading</span>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Profile settings</span>
                                <div class="ml-auto badge badge-first">23</div>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a [routerLink]="" class="nav-link">
                                <span>Active tasks</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="text-center">
                <div class="avatar-icon-wrapper rounded-circle m-0">
                    <div class="d-block p-0 avatar-icon-wrapper m-0 d-90">
                        <div class="rounded-circle overflow-hidden">
                            <img alt="..." class="img-fluid" src="assets/images/avatars/avatar3.jpg"/>
                        </div>
                    </div>
                </div>
                <h3 class="font-weight-bold mt-3">Abigayle Hicks</h3>
                <span class="badge mt-1 mb-4 badge-danger font-size-md px-4 py-1 h-auto">Offline</span>
                <p class="mb-0 text-white-50">Exquisite sense of mere tranquil existence.</p>
                <div class="pt-3">
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-github" tooltip="Github"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'github']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-instagram"
                           tooltip="Instagram"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'instagram']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                    <button class="btn d-50 m-2 p-0 btn-pill btn-secondary shadow-none text-google" tooltip="Google"
                            type="button">
                        <span class="btn-wrapper--icon">
                          <fa-icon [icon]="['fab', 'google']" class="font-size-lg"></fa-icon>
                        </span>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>
